import React from 'react';
import clsx from 'clsx';

/**
 * Small rounded labels (status, counts, tags). `tone` supplies the colours;
 * size and spacing come from `className`. All colours are theme tokens.
 */

export const BADGE_TONES = {
  /** Soft primary colour. */
  'primary-soft': 'bg-agentic-primary-blue/10 text-agentic-primary-blue',
  /** Neutral grey. */
  neutral: 'bg-agentic-gray-100 text-agentic-text-primary',
  /** Success green. */
  success: 'bg-green-100 text-green-800',
  /** No colours of its own: all colours come from `className`. */
  custom: '',
} as const;

export type BadgeTone = keyof typeof BADGE_TONES;

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone };

export const Badge: React.FC<BadgeProps> = ({ tone = 'custom', className, ...props }) => (
  <span className={clsx(BADGE_TONES[tone], className) || undefined} {...props} />
);
